import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Section, Eyebrow, SectionTitle } from './ui.jsx';
import { tokens, monoFont } from '../theme.js';

export default function CompanyStory() {
  const { t } = useTranslation();
  const items = t('company.items', { returnObjects: true });

  return (
    <Section id="company">
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '0.9fr 1.1fr' }, gap: { xs: 5, md: 8 } }}>
        <Box>
          <Eyebrow>{t('company.eyebrow')}</Eyebrow>
          <SectionTitle>{t('company.title')}</SectionTitle>
          <Typography sx={{ color: 'text.secondary', maxWidth: '54ch', mt: -3 }}>{t('company.body')}</Typography>
        </Box>
        <Box sx={{ display: 'grid' }}>
          {items.map((item, index) => (
            <Box key={item.title} sx={{ display: 'grid', gridTemplateColumns: '44px 1fr', gap: 2, py: 2.5, borderTop: `1px solid ${tokens.line}` }}>
              <Typography sx={{ fontFamily: monoFont, color: 'primary.dark', fontSize: '0.75rem' }}>
                {String(index + 1).padStart(2, '0')}
              </Typography>
              <Box>
                <Typography variant="h3" sx={{ mb: 0.75 }}>{item.title}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: '0.95rem' }}>{item.body}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Section>
  );
}
